import { Button, Carousel } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BASE_URL } from '../../constants/Url'
import { useTranslation } from 'react-i18next';
import NewsIcon from '../../assets/icons/News';
import EducationIcon from '../../assets/icons/Education';
import TrendsIcon from '../../assets/icons/Trends';
import ProductIcon from '../../assets/icons/Product';
import DownloadApp from '../../components/DownloadApp';

export default function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCategoryClick = (tag) => {
    navigate(`/news?tag=${tag}`);
  }

  return (
    <div className='w-full'>
      <Carousel className='w-full esi-carousel-banner' draggable dots pauseOnDotsHover pauseOnHover autoplay>
        <img className='esi-banner' src={BASE_URL + "/about-us/Banner.png"} alt='Carousel-Image-1.png' />
        <img className='esi-banner' src={BASE_URL + "/about-us/Banner.png"} alt='Carousel-Image-2.png' />
        <img className='esi-banner' src={BASE_URL + "/about-us/Banner.png"} alt='Carousel-Image-3.png' />
        <img className='esi-banner' src={BASE_URL + "/about-us/Banner.png"} alt='Carousel-Image-4.png' />
      </Carousel>

      <div className='esi-white-space'></div>

      <div className='esi-std-container'>

        {/* about us */}
        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
          <div className='px-[20px] sm:px-0 max-w-[640px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3'>
            <div className='esi-content-title'>
              {t("content_about_us")}
              <div className='esi-secondary-line'></div>
            </div>

            <div className='flex flex-col gap-4 mt-3'>
              <div className='esi-content-paragraph'>{t(`text_about_us_chinese`)}</div>
              <div className='esi-content-paragraph'>{t(`text_about_us_english`)}</div>
              {/* <div className='esi-content-paragraph'>ESTETICA is the world’s leading hair trade magazine founded in Tornio, Italy in 1946 with 18 editions worldwide in different local language.</div>
              <div className='esi-content-paragraph'>ESTETICA 艾絲 was first published in Mainland China 2004. It is a bridge for East and West professional hair industry to link up with global platforms and markets.</div> */}
            </div>
            <div className='mb-0 mt-auto'>
              <Button 
                onClick={() => {
                  window.location.href = 'mailto:support@esiproonline.com';
                }}
              className='esi-std-button'>
                {t("h1_contactUs")}
              </Button>
            </div>
          </div>
          <div className='col-span-2'>
            <img src={BASE_URL + "/about-us/About Us.png"} style={{maxHeight: "462px"}} className='esi-image' alt='ESI About Us' />
          </div>
        </div>

        <div className='esi-white-space'></div>

        <div className='md:grid grid-cols-5 gap-3 flex flex-col'>
          <div className='col-span-2'>
            <img src={BASE_URL + "/about-us/What We Do.png"} className='esi-image' alt='ESI What we do' />
          </div>
          <div className='pt-5 px-[20px] sm:px-[70px] pb-0 sm:pb-10 col-span-3 flex flex-col gap-3'>
            <div className='esi-content-title'>
              {t("h1_whatWeDo")}
              <div className='esi-secondary-line'></div>
            </div>
            <div className='esi-content-paragraph'>{t(`text_what_we_do_chinese`)}</div>
            <div className='esi-content-paragraph mb-3'>{t(`text_what_we_do_english`)}</div>
            {/* <div className='esi-content-paragraph mt-3'>A multi-media hair and beauty platform for beauty professionals to get access to global market news, technic and business management knowledge.</div>
            <div className='esi-content-paragraph'>With the international networks of Estetica, we can provide a global stage for products and hairstylists promotion. Full force to promote the development of hair beauty industry.</div> */}

            <div className='mb-0 mt-auto flex justify-between'>
              <div className='flex flex-col gap-3 items-center cursor-pointer p-lr' onClick={() => handleCategoryClick("产品")}>
                <ProductIcon className='esi-icons' color="#CABDFF" backgroundColor="#2C2B46" />
                <div className='esi-icons-content'>{t("category_product")}</div>
              </div>

              <div className='flex flex-col gap-3 items-center cursor-pointer p-lr' onClick={() => handleCategoryClick("教育")}>
                <EducationIcon className='esi-icons' color="#AFC6FF" backgroundColor="#2C2B46" />
                <div className='esi-icons-content'>{t("category_education")}</div>
              </div>

              <div className='flex flex-col gap-3 items-center cursor-pointer p-lr' onClick={() => handleCategoryClick("型尚")}>
                <NewsIcon className='esi-icons' color='#A5E8C7' backgroundColor="#2C2B46" />
                <div className='esi-icons-content'>{t("category_fashion")}</div>
              </div>

              <div className='flex flex-col gap-3 items-center cursor-pointer p-lr' onClick={() => handleCategoryClick("资讯")}>
                <TrendsIcon className='esi-icons' color="#FFD88D" backgroundColor="#2C2B46" />
                <div className='esi-icons-content'>{t("category_trends")}</div>
              </div>
            </div>
          </div>
        </div>

        <div className='esi-download-app-home mt-4'>
          <DownloadApp className="h-full"
            title={
              <div className='esi-content-title'>
                {t("text_download_app")}
                <div className='esi-secondary-line'></div>
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
}
